import './backdrop.styles.scss';

const Backdrop = ({ children, onClick, visible }) => (
    <div className={`backdrop-container ${visible ? '' : 'hide'}`} onClick={onClick}>
        {children}
    </div>
)

export default Backdrop;
